export const SHOW_TYPES = [
    { value: 'tv_show', label: 'TV Show' },
    { value: 'film', label: 'Film' },
    { value: 'advert', label: 'Advert' },
];

export const DAY_NIGHT_OPTIONS = [
    { value: 'day', label: 'Day' },
    { value: 'night', label: 'Night' },
];

export const SCENE_TYPE_OPTIONS = [
    { value: 'location', label: 'Location' },
    { value: 'set', label: 'Set' },
];

export const YES_NO_OPTIONS = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
];
export const SCENE_COUNT_OPTIONS = Array.from({ length: 10 }, (_, i) => ({
    label: `Scene${i + 1}`,
    value: i + 1
}));

export const EPISODE_COUNT_OPTIONS = Array.from({ length: 10 }, (_, i) => ({
    label: `Episode${i + 1}`,
    value: i + 1
}));